export default __webpack_public_path__ + "static/media/american.75615cbb.png";